(function () {
    'use strict';

    angular
        .module('edufindme')
        .controller('ReportsController', ReportsController);

    ReportsController.$inject = ['$state', '$stateParams', 'FindClientsService','EdufindmeReportService', 'PlanService', '$uibModal'];


    function ReportsController($state, $stateParams, FindClientsService, EdufindmeReportService, PlanService, $uibModal) {
        var vm = this;

        vm.typeSearchList                  = [
                                                {id:'agents',name:'Find Agents'},
                                                {id:'institutions',name:'Find Institutions'}
                                              ];
        vm.clients                         = [];
        vm.noResultMessage                 = '';
        vm.typeSearch                      = [];
        vm.nameSearch                      = [];
        vm.plan                            = [];
        vm.planExpiresOn                   = [
                                                {name:'All'},
                                                {name:'Expires on next 30 days'},
                                                {name:'Already expired'},
                                                {name:'Pending payment'}
                                            ];

        vm.planSelected                    = [];
        vm.planExpiresOnSelected           = {name:'All'};

        vm.getInstitutionsReport           = getInstitutionsReport;
        vm.getAgentsReport                 = getAgentsReport;
        vm.getByFilter                     = getByFilter;
        vm.selectPlans                     = selectPlans;
        vm.openInformation                 = openInformation;
        vm.onChangeFilterType              = onChangeFilterType;

        /*PAGINATION*/
        vm.pageChanged                     = pageChanged;
        vm.setPage                         = setPage;
        vm.totalItems                      = [];
        vm.to                              = [];
        vm.currentPage                     = null;
        vm.itemsPerPage                    = [];
        vm.page                            = 1;

        function activate() {
            vm.selectPlans();
        }

        function getByFilter() {
            if(vm.typeSearch.id == 'institutions') {
                vm.getInstitutionsReport();
            } else {
                vm.getAgentsReport();
            }
        }

        function selectPlans () {
            PlanService.getPlans().then(function(response){
                vm.plan = response.data;
                vm.plan.unshift({id:0,friendly_name:"All"});
            }).catch(function(err) {

            });
        }

        function getInstitutionsReport() {
            vm.query                = {};
            vm.query['type']        = vm.typeSearch.id;
            vm.query['name']        = vm.nameSearch;

            if(typeof vm.planSelected.id !== 'undefined' && vm.planSelected.friendly_name !== 'All') {
                vm.query['plans'] = vm.planSelected.id;
            }

            if(typeof vm.planExpiresOnSelected.name !== 'undefined' && vm.planExpiresOnSelected.name !== 'All') {
                if(vm.planExpiresOnSelected.name == 'Expires on next 30 days')
                    vm.query['expires_in'] = '30 days';
                if(vm.planExpiresOnSelected.name == 'Already expired' || vm.planExpiresOnSelected.name == 'Pending payment')
                    vm.query['expires_in'] = vm.planExpiresOnSelected.name;
            }

            EdufindmeReportService.getClientStatistics(vm.query, vm.page).then(function(response){
                vm.clients    = response.data.data;

                if(typeof vm.clients === 'undefined')
                    vm.noResultMessage = 'Sorry, no results were found!';

                else
                    vm.noResultMessage = '';

                vm.totalItems = response.data.metaData.total;
                vm.to         = response.data.metaData.to;
                vm.setPage(response.data.metaData.current_page);
                vm.itemsPerPage = response.data.metaData.per_page;
            }).catch(function(err) {

            });
        }

        function openInformation(client) {

            $uibModal.open({
                templateUrl: 'templates/edufindme/showInformation/template.modal.html',
                controller: 'OpenInformationEdufindmeController',
                controllerAs:'vm',
                resolve: {
                    client: function () {
                        var id;

                        id = client.id;

                        var serviceSearch = FindClientsService.getExpo(id, vm.typeSearch.id);
                        return serviceSearch.then(function(response){
                            client.expos = response.data;
                            return FindClientsService.getExpoVirtual(id, vm.typeSearch.id);
                        }).then(function(response) {
                            client.expoVirtual = response.data;
                            return FindClientsService.getWebinars(id, vm.typeSearch.id);
                        }).then(function(response) {
                            client.webinars = response.data;
                            return FindClientsService.getGeneralInformation(id, vm.typeSearch.id);
                        }).then(function(response){
                            client.generalInfo = response.data;
                            return client;
                        }).catch(function(err) {
                            return err;
                        });
                    }
                }
            });
        }

        function getAgentsReport() {
            vm.query                = {};
            vm.query['type']        = vm.typeSearch.id;
            vm.query['name']        = vm.nameSearch;

            if(typeof vm.planSelected.id !== 'undefined' && vm.planSelected.friendly_name !== 'All') {
                vm.query['plans'] = vm.planSelected.id;
            }

            if(typeof vm.planExpiresOnSelected.name !== 'undefined' && vm.planExpiresOnSelected.name !== 'All') {
                if(vm.planExpiresOnSelected.name == 'Expires on next 30 days')
                    vm.query['expires_in'] = '30 days';
                if(vm.planExpiresOnSelected.name == 'Already expired' || vm.planExpiresOnSelected.name == 'Pending payment')
                    vm.query['expires_in'] = vm.planExpiresOnSelected.name;
            }

            EdufindmeReportService.getClientStatistics(vm.query, vm.page).then(function(response){
                vm.clients    = response.data.data;

                if(typeof vm.clients === 'undefined'){
                    vm.noResultMessage = 'Sorry, no results were found! :(';
                    vm.totalItems   = null;
                    vm.to           = null;
                    vm.itemsPerPage = null;
                } else {
                    vm.noResultMessage = '';
                    vm.totalItems = response.data.metaData.total;
                    vm.to         = response.data.metaData.to;
                    vm.setPage(response.data.metaData.current_page);
                    vm.itemsPerPage = response.data.metaData.per_page;
                }
                // vm.totalItems = response.data.metaData.total;
                // vm.to         = response.data.metaData.to;
                // vm.setPage(response.data.metaData.current_page);
                // vm.itemsPerPage = response.data.metaData.per_page;
            }).catch(function(err) {

            });
        }

        function onChangeFilterType() {
            vm.clients          = '';
            vm.totalItems       = '';
            vm.to               = '';
            vm.itemsPerPage     = '';
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        activate();
    }

})();